"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));
var _SuccessIcon = _interopRequireDefault(require("../SuccessIcon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AttentionIcon = function AttentionIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.5 25c0 13.531-10.969 24.5-24.5 24.5S.5 38.531.5 25 11.469.5 25 .5 49.5 11.469 49.5 25z",
    fill: "#E02020",
    stroke: "#E02020"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.436 30.577h1.798l.464-13.92h-2.726l.464 13.92zm.899 5.713c.87 0 1.595-.754 1.595-1.595a1.61 1.61 0 0 0-1.595-1.595 1.61 1.61 0 0 0-1.595 1.595c0 .841.725 1.595 1.595 1.595z",
    fill: "#fff"
  }));
};
AttentionIcon.defaultProps = {
  viewBox: "0 0 50 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var TYPES = {
  FAILURE: 'failure',
  SUCCESS: 'success',
  WARNING: 'warning'
};

// react-responsive-modal props
var DEFAULT_OPTIONS = {
  showCloseIcon: true,
  center: true,
  closeOnEsc: true,
  closeOnOverlayClick: true,
  focusTrapped: false
};
var baseCls = 'lt-error-popup';
var classNames = {
  overlay: "".concat(baseCls, "__overlay"),
  modal: "".concat(baseCls, "__modal"),
  closeButton: "".concat(baseCls, "__closeButton"),
  closeIcon: "".concat(baseCls, "__closeIcon")
};
var PopupStyles = (0, _styledComponents.createGlobalStyle)([".", "{background:rgba(145,148,153,.5);}.", "{padding:20px;border-radius:4px;}.", "{top:0;right:-30px;}.", "{fill:", ";}"], classNames.overlay, classNames.modal, classNames.closeButton, classNames.closeIcon, function (props) {
  return props.theme.colors.white;
});
var PopupStylesMobile = (0, _styledComponents.createGlobalStyle)([".", "{padding:20px;border-radius:4px;}.", "{top:5px;right:5px;}.", "{fill:", ";}"], classNames.modal, classNames.closeButton, classNames.closeIcon, function (props) {
  return props.theme.colors.greyLight;
});
var ErrorPopup = function ErrorPopup(_ref) {
  var type = _ref.type,
    isOpen = _ref.isOpen,
    children = _ref.children,
    onClose = _ref.onClose,
    options = _ref.options,
    isMobile = _ref.isMobile;
  var modalParams = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(PopupStyles, null), isMobile && /*#__PURE__*/_react["default"].createElement(PopupStylesMobile, null), /*#__PURE__*/_react["default"].createElement(StyledErrorPopup, (0, _extends2["default"])({
    open: isOpen,
    onClose: onClose,
    classNames: classNames
  }, modalParams), /*#__PURE__*/_react["default"].createElement(StyledContent, null, type === TYPES.WARNING ? /*#__PURE__*/_react["default"].createElement(AttentionIcon, {
    width: 60
  }) : /*#__PURE__*/_react["default"].createElement(_SuccessIcon["default"], {
    success: type === TYPES.SUCCESS
  }), children)));
};
ErrorPopup.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  isMobile: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].shape({}),
  type: _propTypes["default"].oneOf(Object.values(TYPES))
};
ErrorPopup.defaultProps = {
  className: '',
  isMobile: false,
  options: {},
  type: TYPES.FAILURE
};
var StyledErrorPopup = (0, _styledComponents["default"])(_reactResponsiveModal["default"]).withConfig({
  displayName: "ErrorPopup__StyledErrorPopup",
  componentId: "sc-ek9rj-0"
})([""]);
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "ErrorPopup__StyledContent",
  componentId: "sc-ek9rj-1"
})(["display:flex;flex-direction:column;align-items:center;"]);
ErrorPopup.TYPES = TYPES;
var _default = exports["default"] = ErrorPopup;